import { Component, OnInit, Input } from '@angular/core';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import * as moment from 'moment';
import { EventResource } from 'src/app/utils/interfaces/new/event-resource.interface';
import { Event } from 'src/app/utils/interfaces/old/agenda-interface';
import { Router } from '@angular/router';

@Component({
  selector: 'frg-agenda-event',
  templateUrl: './agenda-event.fragment.html',
  styleUrls: ['./agenda-event.fragment.scss']
})
export class AgendaEventFragment implements OnInit {

  @Input() public ressource: EventResource;

  public listEventsAgenda: Array<Event> = [];
  public hypermedEvents: Array<Event> = [];
  public hoveredIndex: number|null = null;
  constructor(
    private _router: Router,
    private agendaService: AgendaService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.initAgendaEvents();
  }

  public async initAgendaEvents() {
    const now = new Date();
    try {
      const events = await this.agendaService.getEvents(
        moment(now).startOf('day').toDate(),
        moment(now).endOf('day').toDate(),
        this.ressource
      );

      const dailyEvents = events.filter((event) => {
        if (event.status) {
          if (event.status.label != 'Annulé' && event.status.label != 'Vu par le médecin') {
            return event;
          }
        } else {
          return event;
        }
      });

      for (const e of dailyEvents) {
        if (e.patient) {
          e.patient.dateNaissance = e.patient.dateNaissance.split('-').reverse().join('-');
        }
        this.listEventsAgenda.push(e);
      }
    } catch (e) {
      console.error(e);
    }
  }

  public async changeEventStatut(event: Event) {
    const statusList = await this.agendaService.getStatus();
    let idViewStatut: string = '';
    for (let statut of statusList) {
      if (statut.label === "Vu par le médecin") {
        idViewStatut = statut.id;
      }
    }
    try {
      await this.agendaService.updateEventStatus(event.id as string, idViewStatut);
      this.listEventsAgenda = [];
      await this.initAgendaEvents();
    } catch (e) {
      console.error(e);
    }
  }

  public getEventColor(event: Event) {
    if (event.type) {
      return event.type.couleur
    } else if (!event.infosAccessible) {
      return '#505050'
    } else {
      return '#8962f8';
    }
  }

  public redirectToRDV(event: Event) {
    if (event.infosAccessible) {
      this._router.navigateByUrl(`user/agenda/update/${event.id}`);
    }
  }

  public redirectToPatient(event: Event) {
    // this.changeEventStatut(event);
    if(event.patient && event.patient.id) {
      this._router.navigateByUrl(`/user/patient/${event.patient.id}`);
    }
  }
}
